/** 현재 시간 */
export const nowSec = () => {
  return 0 | (Date.now() / 1000);
};

/** 토큰 유효성 검사 */
const isValidToken = (token: string) => {
  if (!token) {
    return false;
  }

  const remain = Number(sessionStorage.getItem('expiresAt')) - nowSec();

  // 액세스 토큰 유지 시간이 5분 이하이거나 만료 여부
  return 300 <= remain;
};

/** 토큰 저장 */
const setSession = (accessToken: string | null, refreshToken: string | null, expiresAt: number | null) => {
  if (accessToken) {
    sessionStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('expiresAt', String(expiresAt));
  } else {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('expiresAt');
  }
  if (refreshToken) {
    sessionStorage.setItem('refreshToken', refreshToken);
  }
};

/** 토큰 삭제 */
const tokenDestroy = () => {
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem('expiresAt');
  
  //  자동로그인 정보 삭제
  localStorage.removeItem('keepLogin');
  localStorage.removeItem('rememberMe');
};

export { isValidToken, setSession, tokenDestroy };
